"use client";

export const translatedVariants = {
  es: {
    exists: true,
    title:
      "Conviértete en un Master Teacher certificado con nuestro examen internacional",
    subtitle:
      "Libere su potencial y demuestre su dominio con nuestra estimada certificación. Obtenga reconocimiento en la industria, aumente su credibilidad y abra puertas a interesantes oportunidades profesionales.",
    verification: "Certificado Veirfy",
    certificate_heading: "Ingrese un número de certificado para continuar",
    enter_certificate_number: "Ingrese el número de certificado aquí",
    verifify_certificate: "Verificar",
    signup: "Inscribirse",
    login: "Acceso",
    logout: "Cerrar sesión",
    help: "Ayuda",
    button_text: "Iniciar prueba",
    english: "English",
    spanish: "Español",
    my_account: "Mi cuenta",
    email: "Correo electrónico",
    password: "Contraseña",
    enter_your_email: "Introduce tu correo electrónico",
    enter_your_password: "Ingresa tu contraseña",
    forgot_password: "¿Olvidaste tu contraseña?",
    continue_google: "Continuar con Google",
    no_account: "NO TIENES UNA CUENTA",
    create_one: "CREA UNO",
    signup_heading: "Registrate gratis",
    create_account: "Crea una cuenta",
    signup_with_google: "Regístrate con Google",
    confirmation_text1: `Al hacer clic en "Comenzar", usted confirma su aceptación de nuestra`,
    confirmation_text2: `Términos y condiciones`,
    confirmation_text3: `Así como nuestro`,
    confirmation_text4: `política de privacidad`,
    already_have_account: "YA TIENES UNA CUENTA ?",
    forgot_pass_text1:
      "No te preocupes, te enviaremos instrucciones de reinicio.",
    reset_password: "Restablecer la contraseña",
    back_to_login: "Volver al acceso",
    forgot_pass_text2: "Consultar su correo electrónico",
    forgot_pass_text3: "Nosotros enviamos un enlace de verificación a",
    forgot_pass_text4:
      "Haga clic en el enlace de verificación para acceder al formulario de restablecimiento de contraseña.",
    forgot_pass_text5: "¿No recibiste el correo electrónico?",
    forgot_pass_text6: "Haga clic para reenviar",
    account_doesnt_exist: "La cuenta no existe",
    password_reset_sent:
      "El enlace para restablecer la contraseña ha sido enviado a su correo electrónico.",
    privacy_title: "Política de Privacidad",
    privacy_sub_title:
      "Nuestra Política de Privacidad se actualizó por última vez el [FECHA].",
    privacy_content:
      "<p>Esta Política de Privacidad describe Nuestras políticas y procedimientos sobre la recopilación, uso y divulgación de Su información cuando utiliza el Servicio y le informa sobre Sus derechos de privacidad y cómo la ley lo protege.</p><p>Utilizamos sus datos personales para proporcionar y mejorar el Servicio. Al utilizar el Servicio, usted acepta la recopilación y el uso de información de acuerdo con esta Política de Privacidad. Esta Política de Privacidad fue generada por el Generador de Políticas de Privacidad de TermsFeed.</p>",
    my_account_text_btn: "Tomar una pruebat",
    my_tests: "Mis pruebas",
    personal_info: "Información personal",
    date: "Fecha",
    score: "Puntaje",
    test_language: "Idioma de Prueba",
    certificate_number: "Número Certificado",
    action: "Acción",
    edit: "Editar",
    name: "Nombre",
    general_info: "Información general",
    email_address: "Email Address",
    change_password: "Dirección de correo electrónico",
    old_password: "Contraseña anterior",
    new_password: "Nueva contraseña",
    save_changes: "Guardar cambios",
    enter_your_name: "Introduzca su nombre",
    enter_your_old_password: "Ingrese su antigua contraseña",
    enter_your_new_password: "Introduzca su nueva contraseña",
    password_is_required: "se requiere contraseña",
    password_8_characters: "La contraseña debe tener al menos 8 caracteres",
    create_new_password: "Crear nueva contraseña",
    password_different_to_previously:
      "Su nueva contraseña debe ser diferente a las contraseñas utilizadas anteriormente",
    confirm_password: "Confirmar Contraseña",
    password_reset: "Restablecimiento de contraseña",
    reset_pass_text1: "Su contraseña se ha restablecido correctamente.",
    reset_pass_text2: "Haga clic a continuación para iniciar sesión.",
    email_required: "correo electronico es requerido",
    password_required: "se requiere contraseña",
    invalid_email: "Email inválido",
    email_exists:
      "Ya existe una cuenta con esta dirección de correo electrónico; inicie sesión.",
    profile_updated: "perfil actualizado con éxito",
    wrong_email_or_password: "Correo o contraseña equivocada",
    error_sending_pass_reset:
      "Error al enviar el correo electrónico para restablecer la contraseña",
    old_password_required: "Se requiere contraseña anterior",
    old_password_incorrect: "Contraseña antigua no válida",
    admin_area: "Área de administración",
    google_email:
      "Error al iniciar sesión: este correo electrónico está asociado con una cuenta de autenticación de Google",
    testLanguage: "Idioma de prueba",
    status: "Estado",
    price: "Precio",
    first_name: "Nombre de pila",
    last_name: "Apellido",
    enter_your_first_name: "Ponga su primer nombre",
    enter_your_last_name: "Introduce tu apellido",
    back_btn_text: "Atrás",
    official_certificate: "Certificado Oficial",
    total: "Total",
    features: "Características",
    invalid_cert: "Certificado no válido",
    processing: "Procesando...",
    buy_now: "Comprar ahora",
    payment_info: "Información del pago",
    country_region: "País/Región",
    credit_or_debit_card: "Tarjeta de crédito o débito",
    payment_method: "Método de pago",
    name_on_card: "Nombre en la tarjeta",
    card_number: "Número de tarjeta",
    expiration_date: "Expiración",
    cvc: "Código de seguridad",
    quit_test: "Salir de la prueba",
    quit_test_content:
      "Se perderá todo el progreso. ¿Estás seguro de que quieres salir?",
    quit_test_confirm: "Sí, salir de la prueba",
    invalid_exam:
      "Tuvimos un problema al recuperar la información de su examen; comuníquese con el soporte técnico para obtener ayuda.",
    exam_title: "Bienvenido a la prueba de Lorem Ipsum",
    examDetail1: "50 preguntas de opción múltiple",
    examDetail2: "límite de tiempo de 1 hora",
    examDetail3: "Certificado oficial disponible",
    second_title: "Cosas para recordar",
    thingRem1: "Debes completar este examen en una sesión.",
    thingRem2: "Si cierras la ventana, se perderá todo el progreso.",
    thingRem3: "Podrás volver a realizar el examen.",
    cert_info: "Información certificada",
    upload_your_photo: "Sube tu foto",
    upload_img: "Cargar imagen",
    take_with_webcam: "Tomar con cámara web",
    cancel: "Cancelar",
    continue: "Continuar",
    webcam: "Cámara web",
    webcam_content:
      "Capture y cargue imágenes directamente desde su cámara web.",
    loading: "Cargando...",
    capture_photo: "Capturar foto",
    currency: "Divisa",
  },
  en: {
    exists: true,
    title: "Become a certified Master Teacher with our international exam",
    subtitle:
      "Unleash your potential and demonstrate your mastery with our esteemed certification. Gain industry recognition, boost your credibility, and open doors to exciting career opportunities.",
    verification: "Verify Certificate",
    certificate_heading: "",
    enter_certificate_number: "Enter Certificate Number",
    verifify_certificate: "Verify Certificate",
    signup: "Sign up",
    login: "Log in",
    logout: "Log out",
    help: "Help",
    button_text: "Start test",
    english: "English",
    spanish: "Spanish",
    my_account: "My account",
    email: "Email",
    password: "Password",
    enter_your_email: "Enter your email",
    enter_your_password: "Enter your password",
    forgot_password: "Forgot your password?",
    continue_google: "Continue with Google",
    no_account: "DON'T HAVE AN ACCOUNT?",
    create_one: "Create one",
    signup_heading: "Sign up for free",
    create_account: "Create an account",
    signup_with_google: "Sign up with Google",
    confirmation_text1: `By clicking "Get started," you are confirming your agreement to our`,
    confirmation_text2: `terms and conditions`,
    confirmation_text3: `as well as our`,
    confirmation_text4: `privacy policy`,
    already_have_account: "Already have an account?",
    forgot_pass_text1: "No worries, we'll send you reset instructions.",
    reset_password: "Reset password",
    back_to_login: "Back to log in",
    forgot_pass_text2: "Check your email",
    forgot_pass_text3: " We sent a verification link to",
    forgot_pass_text4:
      "Please click the verification link to access the password reset form.",
    forgot_pass_text5: "Didn’t receive the email?",
    forgot_pass_text6: " Click to resend",
    account_doesnt_exist: "Account doesn't exist",
    password_reset_sent: "Password reset link has been sent to your email.",
    privacy_title: "Privacy Policy",
    privacy_sub_title: "Our Privacy Policy was last updated on [DATE].",
    privacy_content:
      "<p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</p><p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy was generated by TermsFeed Privacy Policy Generator.</p>",
    my_account_text_btn: "Take a Test",
    my_tests: "My Tests",
    personal_info: "Personal Info",
    date: "Date",
    score: "Score",
    test_language: "Test Language",
    certificate_number: "Certificate Number",
    action: "Action",
    edit: "Edit",
    name: "Name",
    general_info: "General Info",
    email_address: "Email Address",
    change_password: "Change Password",
    old_password: "Old Password",
    new_password: "New Password",
    save_changes: "Save Changes",
    enter_your_name: "Enter your name",
    enter_your_old_password: "Enter your old password",
    enter_your_new_password: "Enter your new password",
    password_is_required: "Password is required",
    password_8_characters: "Password must be at least 8 characters",
    create_new_password: "Create new password",
    password_different_to_previously:
      "Your new password must be different to previously used passwords",
    confirm_password: "Confirm password",
    password_reset: "Password reset",
    reset_pass_text1: "Your password has been successfully reset.",
    reset_pass_text2: "Click below to log in.",
    email_required: "Email is required",
    password_required: "Password is required",
    invalid_email: "Invalid email",
    email_exists:
      "An account already exists with this E-mail address - please log in.",
    profile_updated: "Profile updated successfully",
    wrong_email_or_password: "Wrong email or password",
    error_sending_pass_reset: "Error sending password reset email",
    old_password_required: "Old password is required",
    old_password_incorrect: "Invalid old Password",
    admin_area: "Admin Area",
    google_email:
      "Login failed - this E-mail is associated with a Google Authentication account",
    testLanguage: "Test Language",
    status: "Status",
    price: "Price",
    first_name: "First Name",
    last_name: "Last Name",
    enter_your_first_name: "Enter your first name",
    enter_your_last_name: "Enter your last name",
    back_btn_text: "Back",
    official_certificate: "Official Certificate",
    total: "Total",
    features: "Features",
    invalid_cert: "Invalid Certificate",
    processing: "Processing...",
    buy_now: "Buy Now",
    payment_info: "Payment Information",
    country_region: "Country/Region",
    credit_or_debit_card: "Credit or Debit Card",
    payment_method: "Payment Method",
    name_on_card: "Name on Card",
    card_number: "Card Number",
    expiration_date: "Expiry",
    cvc: "Security Code",
    quit_test: "Quit Test",
    quit_test_content:
      "All progress will be lost.Are you sure you want to quit?",
    quit_test_confirm: "Yes, Quit Test",
    invalid_exam:
      "We had an issue retrieving your exam information - please reach out to support for assistance.",
    exam_title: "Welcome to Lorem Ipsum Test",
    examDetail1: "50 multiple choice questions",
    examDetail2: "1 hour time limit",
    examDetail3: "Official certificate available",
    second_title: "Things to Remember",
    thingRem1: "You must complete this exam in one session",
    thingRem2: "If you close the window, all progress will be lost",
    thingRem3: "You will be able to retake the exam",
    upload_your_photo: "Upload your Photo",
    upload_img: "Upload Image",
    take_with_webcam: "Take with Webcam",
    cancel: "Cancel",
    continue: "Continue",
    cert_info: "Certificate Information",
    webcam: "Webcam",
    webcam_content: "Capture & upload picture directly from your webcam.",
    loading: "Loading...",
    capture_photo: "Capture Photo",
    currency: "Currency",
  },
  tr: {
    exists: true,
    title: "Uluslararası sınavımızla sertifikalı bir Usta Öğretmen olun",
    subtitle:
      "Saygın sertifikamızla potansiyelinizi ortaya çıkarın ve ustalığınızı gösterin. Sektörde tanınırlık kazanın, güvenilirliğinizi artırın ve heyecan verici kariyer fırsatlarının kapılarını açın.",
    verification: "Sertifikayı Doğrula",
    certificate_heading: "",
    enter_certificate_number: "Enter Certificate Number",
    verifify_certificate: "Verify Certificate",
    signup: "Sign up",
    login: "Log in",
    logout: "Log out",
    help: "Help",
    button_text: "Start test",
    english: "English",
    spanish: "Spanish",
    my_account: "My account",
    email: "Email",
    password: "Password",
    enter_your_email: "Enter your email",
    enter_your_password: "Enter your password",
    forgot_password: "Forgot your password?",
    continue_google: "Continue with Google",
    no_account: "DON'T HAVE AN ACCOUNT?",
    create_one: "Create one",
    signup_heading: "Sign up for free",
    create_account: "Create an account",
    signup_with_google: "Sign up with Google",
    confirmation_text1: `By clicking "Get started," you are confirming your agreement to our`,
    confirmation_text2: `terms and conditions`,
    confirmation_text3: `as well as our`,
    confirmation_text4: `privacy policy`,
    already_have_account: "Already have an account?",
    forgot_pass_text1: "No worries, we'll send you reset instructions.",
    reset_password: "Reset password",
    back_to_login: "Back to log in",
    forgot_pass_text2: "Check your email",
    forgot_pass_text3: " We sent a verification link to",
    forgot_pass_text4:
      "Please click the verification link to access the password reset form.",
    forgot_pass_text5: "Didn’t receive the email?",
    forgot_pass_text6: " Click to resend",
    account_doesnt_exist: "Account doesn't exist",
    password_reset_sent: "Password reset link has been sent to your email.",
    privacy_title: "Privacy Policy",
    privacy_sub_title: "Our Privacy Policy was last updated on [DATE].",
    privacy_content:
      "<p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</p><p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy was generated by TermsFeed Privacy Policy Generator.</p>",
    my_account_text_btn: "Take a Test",
    my_tests: "My Tests",
    personal_info: "Personal Info",
    date: "Date",
    score: "Score",
    test_language: "Test Language",
    certificate_number: "Certificate Number",
    action: "Action",
    edit: "Edit",
    name: "Name",
    general_info: "General Info",
    email_address: "Email Address",
    change_password: "Change Password",
    old_password: "Old Password",
    new_password: "New Password",
    save_changes: "Save Changes",
    enter_your_name: "Enter your name",
    enter_your_old_password: "Enter your old password",
    enter_your_new_password: "Enter your new password",
    password_is_required: "Password is required",
    password_8_characters: "Password must be at least 8 characters",
    create_new_password: "Create new password",
    password_different_to_previously:
      "Your new password must be different to previously used passwords",
    confirm_password: "Confirm password",
    password_reset: "Password reset",
    reset_pass_text1: "Your password has been successfully reset.",
    reset_pass_text2: "Click below to log in.",
    email_required: "Email is required",
    password_required: "Password is required",
    invalid_email: "Invalid email",
    email_exists:
      "An account already exists with this E-mail address - please log in.",
    profile_updated: "Profile updated successfully",
    wrong_email_or_password: "Wrong email or password",
    error_sending_pass_reset: "Error sending password reset email",
    old_password_required: "Old password is required",
    old_password_incorrect: "Invalid old Password",
    admin_area: "Admin Area",
    google_email:
      "Login failed - this E-mail is associated with a Google Authentication account",
    testLanguage: "Test Language",
    status: "Status",
    price: "Price",
    first_name: "First Name",
    last_name: "Last Name",
    enter_your_first_name: "Enter your first name",
    enter_your_last_name: "Enter your last name",
    back_btn_text: "Geri",
    official_certificate: "Resmi Sertifika",
    total: "Toplam",
    features: "Özellikler",
    invalid_cert: "Geçersiz Sertifika",
    processing: "İşleme...",
    buy_now: "Şimdi al",
    payment_info: "ödeme bilgileri",
    country_region: "Ülke/Bölge",
    credit_or_debit_card: "Kredi veya Banka Kartı",
    payment_method: "Ödeme yöntemi",
    name_on_card: "Karttaki İsim",
    card_number: "Kart numarası",
    expiration_date: "Son kullanma tarihi",
    cvc: "Güvenlik Kodu",
    quit_test: "Testten Çık",
    quit_test_content:
      "Tüm ilerlemeniz kaybolacak. Çıkmak istediğinizden emin misiniz?",
    quit_test_confirm: "Evet, Testten Çık",
    invalid_exam:
      "Sınav bilgilerinizi alırken bir sorun yaşadık; lütfen yardım için destek ekibiyle iletişime geçin.",
    exam_title: "Lorem Ipsum Test'e hoş geldiniz",
    examDetail1: "50 çoktan seçmeli soru",
    examDetail2: "1 saatlik zaman sınırı",
    examDetail3: "Resmi sertifika mevcut",
    second_title: "Hatırlanacak şeyler",
    thingRem1: "Bu sınavı tek oturumda tamamlamanız gerekmektedir.",
    thingRem2: "Pencereyi kapatırsanız tüm ilerleme kaybolacak",
    thingRem3: "Sınava tekrar girebileceksiniz",
    upload_your_photo: "Fotoğrafını yükle",
    upload_img: "Fotoğraf yükleniyor",
    take_with_webcam: "Web kamerasıyla",
    cancel: "İptal etmek",
    continue: "Devam etmek",
    cert_info: "Sertifika bilgisi",
    webcam: "Web kamerası",
    webcam_content: "Doğrudan web kameranızdan fotoğraf çekin ve yükleyin.",
    loading: "Yükleniyor...",
    capture_photo: "Fotoğraf Çek",
    currency: "Currency",
  },
};

export const isoLanguagesMobileNames = {
  es: "ES",
  en: "EN",
  tr: "TR",
};

export const nativeLanguageNames = {
  es: "Español",
  en: "English",
  tr: "Türkçe",
};

export const languageCodes = [
  { name: "English", code: "en" },
  { name: "Español", code: "es" },
  { name: "Türkçe", code: "tr" },
];
